module.exports = __webpack_public_path__ + "img/kenya.f4e9b71a.jpg";